import type { FaireProductEntity } from "../../entity_types/product";

export const p_zr3b3xkpqw: FaireProductEntity = {
  token: "p_zr3b3xkpqw",
  type: "product",
  name: "Aceite de Moska",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/c6f339c17643975b90d390f0826b40ac4b4e970f0c6f09704790ace67189d7be.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 28,
  description: "Aceite de Moska for wholesale.",
  tags: ["haircare"],
  caseSize: 1,
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
